var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-empty-state',{attrs:{"md-icon":_vm.icon,"md-label":_vm.title,"md-description":_vm.description}},[_c('md-button',{staticClass:"md-primary md-raised",on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(_vm._s(_vm.buttonText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }